import { gql, useMutation } from '@apollo/client';
import {
  Loyalty_SubmitTermsDecisionMutation,
  Loyalty_SubmitTermsDecisionMutationVariables,
} from '@/types';
import { useCallback } from 'react';

export interface SubmitLoyaltyTermsDecisionParams {
  email?: string | null;
  isAccepted: boolean;
  loyaltyProgramTermsUUID: string;
  supplierLoyaltyProgramRestaurantUUID: string;
}

export const SUBMIT_LOYALTY_TERMS_DECISION_MUTATION = gql`
  mutation Loyalty_SubmitTermsDecision(
    $supplierLoyaltyProgramRestaurantUUID: uuid!
    $loyaltyProgramTermsUUID: uuid!
    $email: String
    $isAccepted: Boolean!
  ) {
    submitLoyaltyProgramTermsDecision(
      supplier_loyalty_program_restaurant_id: $supplierLoyaltyProgramRestaurantUUID
      loyalty_program_terms_id: $loyaltyProgramTermsUUID
      email: $email
      is_accepted: $isAccepted
    ) {
      alert_level
      alert_message
      error_code
      supplier_loyalty_program_restaurant_id
    }
  }
`;

export const useSubmitLoyaltyTermsDecision = () => {
  const [submit, { loading: isSubmitting }] = useMutation<
    Loyalty_SubmitTermsDecisionMutation,
    Loyalty_SubmitTermsDecisionMutationVariables
  >(SUBMIT_LOYALTY_TERMS_DECISION_MUTATION, {
    fetchPolicy: 'no-cache',
  });

  const submitLoyaltyTermsDecision = useCallback(
    async (params: SubmitLoyaltyTermsDecisionParams) => {
      const { data } = await submit({
        variables: {
          email: params.email,
          isAccepted: params.isAccepted,
          loyaltyProgramTermsUUID: params.loyaltyProgramTermsUUID,
          supplierLoyaltyProgramRestaurantUUID:
            params.supplierLoyaltyProgramRestaurantUUID,
        },
      });
      return data?.submitLoyaltyProgramTermsDecision ?? null;
    },
    [submit],
  );

  return { isSubmitting, submitLoyaltyTermsDecision };
};
